import Styles from './Item.scss';

import Template from './Item.hbs';
import ProgressBar from 'views/components/progressBar/ProgressBar.svelte'
import { getStudentProgressBarFragments } from 'util/ProgressUtil'

export default class Item extends BaseView {

    get events() {
        return {
            click: 'onClick',
        }
    }

    /**
     * @param {Object} options options
     * @param {Backbone.Model} options.activityModel activity model
     * @param {Backbone.View} options.work_on linear activity view
     */
    initialize({
        activityModel,
        work_on,
    }) {
        this.work_on = work_on

        this.setElement(Template({
            Styles,
            index: this.model.get('index'),
            label: this.model.getShortText(),
            hasProgress: Backbone.Model.user.get('is_student') && activityModel.tasks.length,
            isActive:
                this.work_on.activeItem.model !== activityModel &&
                this.model.get('sequence') === this.work_on.activeItem.model.get('sequence'),
            contentDomain: this.model.getContentDomainItem()?.abbreviation
        }))

        // Students will receive a sidebar with their latest progress inside the activity.
        // Teachers will only receive an overview of the task groups inside the activity, so they can
        // make use of the quick navigation.
        if (!ACL.checkRole(ACL.roles.STUDENT)) {
            return
        }

        const countTasks = this.model.tasks.length
        const taskIds = this.model.tasks.pluck('id')

        let countMade = 0
        let countChecked = 0
        let score = 0

        for (const response of activityModel.responses) {

            if (!response.has('json_answer')) {
                continue
            }

            if (taskIds.includes(response.get('task_id'))) {
                countMade++

                if (response.get('score') !== -1) {
                    countChecked++
                    score += parseFloat(response.get('score'))
                }
            }

        }

        // If the task group contains tasks, add a progress bar
        if (countTasks > 0) {
            this.addSvelteChildView('.js-progress', ProgressBar, {
                fragments: activityModel.get('showScores') ? getStudentProgressBarFragments(
                    true, false,
                    countChecked ?
                        score / countChecked : 0,
                    countChecked / countMade,
                    countTasks ?
                        countMade / countTasks : 0
                ) : {
                    blue: countMade / countTasks
                }
            })
        }
    }

    /**
     * When item is clicked, navigate to related task group.
     *
     * @returns {Boolean} abort
     */
    onClick() {
        this.work_on.navigationBar.setActiveItem(this.model.get('sequence'))
        Backbone.View.sidebar.closeSidebar()
        return false
    }

}
